module.exports = __webpack_public_path__ + "img/image-balanced-desktop.1fff8d1d.png";